/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ArrowRightIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "arrow-right", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M18.5 12.5H6", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M13 7L18.5 12.5L13 18", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ArrowRightIcon);
export default ForwardRef;
//# sourceMappingURL=arrowRightIcon.js.map